var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass,attrs:{"id":_vm.containerId}},[_c('canvas',{ref:"chart",attrs:{"id":"canvas-chart-id"}})])}
var staticRenderFns = []

export { render, staticRenderFns }